<template>
  <div class="table">
    <!-- 评论盒子 -->
    <comment-box
      v-model="comment_show"
      v-if="comment_show"
      :item-id="item_id"
      @getCommentTxt="getCommentTxt"
      @close="close"
    />
    <van-skeleton title avatar :row="3" :loading="data_loading">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="no_more_info"
          @load="onLoad"
        >
          <van-cell v-for="(item, index) in list" :key="index">
            <div v-if="list.length" class="content_list">
              <!-- 头部内容 -->
              <div class="top_box">
                <div
                  :style="{
                    background: 'url(' + item.user.avatar + ') no-repeat',
                    backgroundSize: '100% 100%'
                  }"
                  class="avatar"
                >
                  <img
                    v-if="item.user.avatar_frame_id && avatar_frames.length"
                    :src="getAvatarPic(item.user.avatar_frame_id)"
                  />
                </div>
                <div class="nikename">{{ item.user.nickname }}</div>
                <div @click="concern(item)" class="concern">
                  {{ item.user.is_follow ? "取消关注" : "+ 关注" }}
                </div>
              </div>
              <!-- 帖子内容 -->
              <div class="content" data-id="6575">
                <p
                  v-if="type"
                  v-html="common_method.cotentReg(item.content)"
                  @click="toMoreInfo(item.id)"
                  class="text_info"
                ></p>
                <p
                  v-else
                  v-html="common_method.cotentReg(item.short_content)"
                  @click="toMoreInfo(item.id)"
                  class="text_info"
                ></p>
                <!-- 帖子来源 -->
                <div class="item_original" v-if="item.original">
                  <div class="item_original_info">
                    <span class="original_username"
                      >{{ item.original.user.nickname }}：</span
                    >
                    <span
                      v-html="
                        common_method.cotentReg(item.original.short_content)
                      "
                    ></span>
                  </div>
                </div>
                <!-- 图片、视频资源 -->
                <div v-if="item.resources" class="content_pic">
                  <div v-for="(item2, index2) in item.resources" :key="index2">
                    <video
                      v-if="item2.type === 2"
                      class="video_item"
                      playsinline
                      preload="auto"
                      autoplay
                      alt="视频"
                    >
                      <source :src="item2.link" type="video/mp4" />
                    </video>
                    <div
                      v-if="item2.type === 2"
                      @click="showVideo(item2.link)"
                      class="video_mark"
                    >
                      <van-icon
                        class="play_btn"
                        color="#1989fa"
                        name="play-circle-o"
                      />
                    </div>
                    <img
                      v-if="item2.type === 1"
                      :src="item2.link"
                      @click="showImg(item2.link)"
                      alt="图片"
                    />
                  </div>
                  <p style="clear: both;"></p>
                </div>
                <p v-if="item.topic" class="game_info">
                  <i></i>
                  <span>{{ item.topic.name }}</span>
                </p>
              </div>

              <!-- 转发/评论/点赞列表 -->
              <div v-if="type" class="social_info">
                <van-tabs v-model="table_active" swipeable animated>
                  <van-tab
                    v-for="(item1, index1) in table_list"
                    :badge="item[item1.num]"
                    :key="index1"
                    :title="item1.name"
                    title-class="nav_tab"
                  >
                    <nav-item v-if="nav_show" :nav-type="item1.value" />
                  </van-tab>
                </van-tabs>
              </div>
              <div v-if="type" class="social is_show_social">
                <div @click="transpond()" class="transpond_span">
                  <i class="transpond_icon"></i>
                  转发
                </div>
                <div @click="socialComment(item.id)" class="comment_span">
                  <i class="comment_icon"></i>
                  评论
                </div>
                <div @click="socialLike(item)" class="like_span">
                  <i :class="{ like_icon: true, is_like: item.is_like }"></i>
                  <span class="like_num">点赞</span>
                </div>
              </div>

              <!-- 帖子底部功能（简单） -->
              <div v-if="!type" class="social">
                <div @click="transpond()" class="transpond_span">
                  <i class="transpond_icon"></i>
                  {{ item.forward_num }}
                </div>
                <div @click="toMoreInfo(item.id)" class="comment_span">
                  <i class="comment_icon"></i>
                  {{ item.comment_num }}
                </div>
                <div @click="socialLike(item)" class="like_span">
                  <i :class="{ like_icon: true, is_like: item.is_like }"></i>
                  <span class="like_num"> {{ item.like_num }}</span>
                </div>
              </div>
            </div>
          </van-cell>
        </van-list>
      </van-pull-refresh>
    </van-skeleton>
    <!-- 发帖按钮 -->
    <div @click="transpond()" class="add_item_box">
      <van-icon name="add" color="#1989fa" size="10vw" />
    </div>
    <!-- 下载盒子 -->
    <download
      v-model="download_show"
      v-if="download_show"
      @closepop="closepop"
    />

    <!-- 视频弹窗 -->
    <van-dialog
      v-if="video_show"
      v-model="video_show"
      width="70vw"
      closeOnClickOverlay
      :showConfirmButton="false"
      getContainer="#app"
    >
      <video
        class="video_more"
        preload="auto"
        alt="视频"
        autoplay
        playsinline
        controls
      >
        <source :src="video_src" type="video/mp4" />
      </video>
    </van-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import {
  List,
  Cell,
  PullRefresh,
  Skeleton,
  Tab,
  Tabs,
  ImagePreview,
  Dialog,
  Toast,
  Icon
} from "vant";
import {
  getTopicsItemApi,
  getDiscoveryApi,
  likesPostsApi,
  cancelLikesPostsApi,
  isFollowApi,
  offFollowApi,
  getTopicsInfoApi
} from "@/api/home";

import common from "@/utils/common";

export default {
  props: {
    type: {
      type: Boolean
    }
  },
  name: "home",
  components: {
    [List.name]: List,
    [Cell.name]: Cell,
    [PullRefresh.name]: PullRefresh,
    [Skeleton.name]: Skeleton,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [ImagePreview.name]: ImagePreview,
    [Dialog.Component.name]: Dialog.Component,
    [Toast.name]: Toast,
    [Icon.name]: Icon,
    download: () => import("./download"),
    navItem: () => import("./nav-item"),
    commentBox: () => import("./commen-box")
  },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      download_show: false,
      data_loading: true,
      no_more_info: "没有更多了",
      comment_show: false,
      topic_id: this.$store.state.topic_id,
      avatar_frames: [],
      item_id: 0, // 帖子id
      page: 1,
      video_show: false, // 视频弹窗
      video_src: "", // 视频url
      common_method: common, // 公共js
      table_active: "transpond", // 默认显示转发列表
      nav_show: true,
      table_list: [
        { name: "转发", value: "transpond", num: "forward_num" },
        { name: "评论", value: "comment", num: "comment_num" },
        { name: "点赞", value: "like", num: "like_num" }
      ]
    };
  },

  created() {
    this.avatar_frames = this.$store.state.avatar_frames;
  },

  mounted() {
    this.data_loading = false;
  },
  methods: {
    onLoad() {
      // 当页面为列表时
      if (!this.type) {
        this.no_more_info = "没有更多了";
        if (this.refreshing) {
          this.list = [];
          this.refreshing = false;
        }

        // 判断是否有圈子id
        if (this.topic_id) {
          // 获取圈子页帖子数据
          this.getTopicsItem(this.topic_id).then(res => {
            this.getDataSucceed(res);
          });
        } else {
          // 获取发现页帖子数据
          this.getDiscovery().then(res => {
            this.getDataSucceed(res);
          });
        }
      } else {
        // 页面为详情信息时直接获取帖子详情信息
        this.no_more_info = "";
        const id = this.$route.params.id;
        this.getTopicsInfo(id).then(res => {
          this.list = [res];
        });
        this.refreshing = false;
        this.finished = true; // 全部加载完成
        this.loading = false;
      }
    },

    // 获取帖子数据成功后
    getDataSucceed(res) {
      if (res.has_more) {
        this.list = this.list.concat(res.items);
        this.page++;
      } else {
        this.list = this.list.concat(res.items);
        this.finished = true;
      }
      this.loading = false;
    },

    // 获取头像框数据
    getAvatarPic(id) {
      return this.avatar_frames.filter(item => {
        return item.id === id;
      })[0].link;
    },

    // 获取圈子帖子
    getTopicsItem(topic_id) {
      return new Promise(resolve => {
        getTopicsItemApi(topic_id, { page: this.page }).then(response => {
          resolve(response.data);
        });
      });
    },

    // 获取发现页帖子
    getDiscovery() {
      return new Promise(resolve => {
        getDiscoveryApi({ page: this.page }).then(response => {
          resolve(response.data);
        });
      });
    },

    // 跳转消息详情页
    toMoreInfo(id) {
      this.$router.push({ path: `/more-info/${id}` });
    },

    // 获取帖子详情信息
    getTopicsInfo(id) {
      return new Promise(resolve => {
        getTopicsInfoApi(id).then(response => {
          resolve(response.data);
        });
      });
    },

    // 评论帖子
    socialComment(id) {
      this.item_id = id;
      this.comment_show = true;
    },

    //点击关注/取消关注
    concern(item) {
      // 关注
      if (!item.user.is_follow) {
        isFollowApi(item.user.id).then(() => {
          Toast.success("关注成功！");
          item.user.is_follow = true;
        });
      } else {
        // 取消关注
        offFollowApi(item.user.id).then(() => {
          Toast.success("取消成功！");
          item.user.is_follow = false;
        });
      }
    },

    // 点击图片
    showImg(src) {
      ImagePreview({
        images: [src],
        closeable: true
      });
    },

    // 点击打开视频
    showVideo(src) {
      this.video_src = src;
      this.video_show = true;
    },

    // 点击转发出现下载引导页
    transpond() {
      this.download_show = true;
    },

    closepop() {
      this.download_show = false;
    },

    // 帖子点赞
    socialLike(item) {
      // 点赞
      if (!item.is_like) {
        likesPostsApi(item.id).then(() => {
          item.like_num++;
          item.is_like = true;
        });
      } else {
        cancelLikesPostsApi(item.id).then(() => {
          item.like_num--;
          item.is_like = false;
        });
      }
    },

    // 更新评论内容
    getCommentTxt(status) {
      if (status) {
        this.nav_show = false;
        this.$nextTick(() => {
          this.nav_show = true;
        });
      }
      this.close();
    },

    // 关闭评论盒子
    close() {
      this.comment_show = false;
    },

    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.page = 1;
      this.onLoad();
    }
  }
};
</script>

<style>
.social_info .van-tabs__nav {
  width: 65%;
}
.video_mark {
  width: 27vw;
  height: 27vw;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 5;
}

.play_btn {
  font-size: 12vw;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-52%, -50%);
}

/* 帖子来源 */
.item_original_info {
  width: 100%;
  padding: 2vw;
  background-color: #f1f1f1;
  border-radius: 5px;
  word-wrap: break-word;
  word-break: normal;
}

.original_username {
  color: #2b87eb;
}

@import "../assets/index.css";
@import "../assets/common.css";
@import "../assets/comment.css";
</style>
